// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"84e24c49","745":"b1125aad"}[chunkId] + ".chunk.css";
};